// The "set up two-factor within N days" reminder. The sign-in response carries `mfaGrace`
// ({ daysLeft, deadline }) when the organisation requires 2FA and this person has not enrolled;
// it is kept for the browser session so the reminder survives page loads, and cleared once they
// enrol. Storage can be unavailable (private mode), so every access is guarded.
const KEY = 'rostery.mfaGrace';

export function saveMfaGrace(grace) {
  try {
    if (grace && grace.deadline) sessionStorage.setItem(KEY, JSON.stringify({ deadline: grace.deadline }));
    else sessionStorage.removeItem(KEY);
  } catch { /* storage unavailable: no reminder this session */ }
}

export function clearMfaGrace() {
  try { sessionStorage.removeItem(KEY); } catch { /* nothing stored */ }
}

// Days left, worked out from the stored deadline so the count stays right if the tab is left open.
export function readMfaGrace() {
  try {
    const v = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (!v || !v.deadline) return null;
    const daysLeft = Math.max(0, Math.ceil((new Date(v.deadline).getTime() - Date.now()) / 86400000));
    return { daysLeft, deadline: v.deadline };
  } catch { return null; }
}
